import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'relements/build/esm/ui/icon';

import InvisibleIcon from '@src/components/Icon/invisible.svg';
import VisibleIcon from '@src/components/Icon/visible.svg';
import SubstoryNavigation from '@src/components/SubstoryNavigation';
import ButtonV2 from '@src/components/ButtonV2';

import Chat from '@src/containers/SubStories/SubStoryNavigation/icons/chat.svg';

import styles from './SmallTalkNavigation.scss';

function SmallTalkNavigation({
  nodes,
  activeId,
  onChange,
  onTestBotClick,
  onToggle,
  editingDisabled,
}) {
  const injectedNodes = nodes.map((node, i) => {
    const disabled = !node.active;
    return {
      ...node,
      contextMenu: editingDisabled
        ? []
        : [
            {
              title: !disabled ? 'Deactivate Step' : 'Activate Step',
              icon: !disabled ? InvisibleIcon : VisibleIcon,
              onClick: () => onToggle(node, i),
            },
          ],
    };
  });

  return (
    <div>
      <SubstoryNavigation
        active
        nodes={injectedNodes}
        className={styles.smallTalkNavigation}
        smallTalkNav
        draggable={false}
        activeNodeId={activeId}
        onNodeChange={onChange}
        prefixComponent={
          <div className={styles.smallTalkNavigationHeader}>Steps</div>
        }
        postfixComponent={(
          <div className={styles.testBotWrapper}>
            <ButtonV2 onClick={onTestBotClick} prefixClassName={styles.testBot}>
              <Icon src={Chat} className={styles.testBotIcon} />
              <span className={styles.testBotText}>Test Bot</span>
            </ButtonV2>
          </div>
        )}
      />
    </div>
  );
}

SmallTalkNavigation.propTypes = {
  activeId: PropTypes.string,
  nodes: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  onTestBotClick: PropTypes.func,
  onToggle: PropTypes.func,
  editingDisabled: PropTypes.bool,
};

SmallTalkNavigation.defaultProps = {
  activeId: '',
  onChange: () => {},
  onTestBotClick: () => {},
  onToggle: () => {},
  nodes: [],
  editingDisabled: false,
};

export default SmallTalkNavigation;
